// Build marketplace URLs for a given opportunity / set.
//
// Direct /dp/{asin} URLs only work when the ASIN is VERIFIED (matched by a
// live Keepa scan or manually entered by the user). Unverified ASINs from the
// initial seed could be wrong (e.g. tank-top instead of LEGO set) so for those
// we fall back to a search URL by set number.

const bareSet = (setNumber) => (setNumber || "").split("-")[0];

export const amazonUrl = (asin, setNumber, verified = false) => {
  if (verified && asin && asin.length >= 8) {
    return `https://www.amazon.com/dp/${asin}`;
  }
  const set = bareSet(setNumber);
  if (set) {
    return `https://www.amazon.com/s?k=LEGO+${encodeURIComponent(set)}&i=toys-and-games`;
  }
  if (asin) {
    return `https://www.amazon.com/dp/${asin}`;
  }
  return null;
};

export const bricklinkUrl = (setNumber) => {
  if (!setNumber) return null;
  const canonical = setNumber.includes("-") ? setNumber : `${setNumber}-1`;
  return `https://www.bricklink.com/v2/catalog/catalogitem.page?S=${canonical}#T=S&O={"iconly":0}`;
};

export const bricklinkPriceGuideUrl = (setNumber) => {
  if (!setNumber) return null;
  const canonical = setNumber.includes("-") ? setNumber : `${setNumber}-1`;
  return `https://www.bricklink.com/catalogPG.asp?S=${canonical}`;
};
